import FormTemplateType from '../../../constants/FormTemplateType';

// Application, acceptance and public forms are completed from their link, so they never have recipients and the
// Go Live box does not mention them (Maria, 24 October 2026).
const PUBLIC_LINK_TEMPLATE_TYPES = [FormTemplateType.application, FormTemplateType.acceptance, FormTemplateType.shareable];

export const isPublicLinkTemplate = templateType => PUBLIC_LINK_TEMPLATE_TYPES.includes(templateType);

export const goLiveMessage = ({isCommunicationForm, hasRecipients, templateType}) => {
    if (isCommunicationForm) return 'This will save the form and send the communication to all assigned recipients immediately.';
    if (isPublicLinkTemplate(templateType)) return 'This will save the form and make it live immediately.';
    if (hasRecipients) return 'This will save the form and make it live immediately. Email notifications will be sent to all assigned recipients.';
    return 'This form does not have any recipients yet. It will be sent once you add recipients in Form Settings.';
};
